import BRAND from '@/brand';
import HentpostLanding from '@/pages/landing/HentpostLanding';
import DigitalboxLanding from '@/pages/landing/DigitalboxLanding';

// Forsiden er det ene sted hvor brandene ikke deler layout — hver har sit eget
// salgsdesign. Alt bag login er faelles.
//
// Ruter og imports peger stadig paa '@/pages/LandingPage', saa resten af appen
// ikke behoever vide at der findes to.
const SIDER = {
    hentpost: HentpostLanding,
    digitalbox: DigitalboxLanding,
};

export default function LandingPage() {
    const Side = SIDER[BRAND.key] || HentpostLanding;
    return <Side />;
}
